module.exports = __webpack_public_path__ + "img/NER.d37bec95.svg";